import { Link } from 'react-router';
import { useT } from '@/ui/i18n';

export function NotFoundPage() {
  const t = useT();
  return (
    <div className="card">
      <p>{t('misc.notFound')}</p>
      <Link to="/">{t('nav.home')}</Link>
    </div>
  );
}
